import React, { Component } from 'react';

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      type: this.props.coffees.length && this.props.coffees[0].id,
      size: this.props.coffees.length && this.props.coffees[0].sizes.length &&
        this.props.coffees[0].sizes[0].id
    }
  }

  componentDidMount(){
    var order = this.props.order;
    order.items = [];//order.items.filter(x=> x.type === 'coffee');
    order.type = 'coffee';
    this.props.updateOrder(order);
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.coffees !== this.props.coffees)
      this.setState({
        type: nextProps.coffees.length && nextProps.coffees[0].id,
        size: nextProps.coffees.length && nextProps.coffees[0].sizes.length &&
          nextProps.coffees[0].sizes[0].id
      })
  }

  handleChange(e){
    var newState = {},
      sizeInt = parseInt(e.target.value, 10);
    newState[e.target.name] = sizeInt;
    if(e.target.name === 'type')
      newState.size = this.getSelectedCoffee(sizeInt).sizes[0].id
    this.setState(newState);
  }

  handleOrderChange(e){
    this.props.order[e.target.name] = e.target.value;
    if(e.target.name === 'customer')
      this.props.order[e.target.name] = this.props.people.find(x=> x.id === parseInt(e.target.value, 10))
    this.props.updateOrder(this.props.order);
  }

  getSelectedCoffee(id){
    return this.props.coffees.find(x=> id ? x.id === id : x.id === this.state.type)
  }

  getSelectedPrice(){
    if(!this.props.coffees.length) return 0;
    if(!(this.state.size && this.state.type)) return 0;
    var coffee = this.getSelectedCoffee();
    var size = coffee.sizes.find(x=>x.id === this.state.size);
    return size.price;
  }

  toCurrency(num){
    return (Math.ceil(num * 100) / 100).toFixed(2)
  }

  handleNext(e){
    if(this.coffeeItems().length === 0)
      e.preventDefault();
  }

  addCoffee(e){
    e.preventDefault();
    var selected = this.getSelectedCoffee(),
      size = selected.sizes.find(x=>x.id === this.state.size),
      order = this.props.order;
    order.items.push({
      type: 'coffee',
      name: selected.name,
      price: size.price,
      id: selected.id,
      size: size.name,
      size_id: size.id,
      quantity: 1
    })
    this.props.updateOrder(order);
    console.log(order);
  }

  coffeeItems(){
    return this.props.order.items.filter(x=> x.type === 'coffee');
  }

  getTotal(){
    if(!this.coffeeItems().length) return 0;
    return this.coffeeItems().reduce((total, coffee)=> total + coffee.price, 0)
  }

  render() {
    var person = this.props.order.customer,
      coffeeItems = this.coffeeItems();
    return person ? (
      <div className="">
        <h1>New Coffee Order</h1>

        { this.props.coffees.length ? (
          <div>

            <form className="form-horizontal">
              <div className="form-group">
                <label htmlFor="orderfor" className="col-sm-2 control-label">Order For</label>
                <div className="col-sm-10">
                  <select className="form-control"
                    id="orderfor"
                    name="customer" onChange={this.handleOrderChange.bind(this)}>
                    {this.props.people.map((person, i)=>
                      <option key={i} value={person.id}>{person.name}</option>
                    )}
                  </select>
                  <div className="text-right mobile-neg-mbtm">
                    <a href="#/people">Add/Edit People</a>
                  </div>
                </div>
              </div>

              { person.school.coffee ? (
                <div>

                    <div className="form-group">
                      <label htmlFor="coffeetype" className="col-sm-2 control-label">Coffee</label>
                      <div className="col-sm-10">
                        <select className="form-control"
                          id="coffeetype"
                          name="type" onChange={this.handleChange.bind(this)}>
                            {this.props.coffees.map((coffee, i)=>
                              <option key={i} value={coffee.id}>{coffee.name}</option>
                            )}
                        </select>
                      </div>
                    </div>

                    <div className="form-group">
                      <label htmlFor="coffeesize" className="col-sm-2 control-label">Size</label>
                      <div className="col-sm-10">
                        { this.state.type ? (
                          <select className="form-control"
                            id="coffeesize"
                            name="size" onChange={this.handleChange.bind(this)}>
                              { this.getSelectedCoffee().sizes.map(size=>
                                <option key={size.id} value={size.id}>{size.name} ${this.toCurrency(size.price)}</option>
                              )}
                          </select>
                        ) : null}
                      </div>
                    </div>

                  <div className="row">

                    <div className="text-center">
                      <button className="btn btn-default"
                        onClick={this.addCoffee.bind(this)}>Add to order</button>
                    </div>

                  </div>

                  <br />

                  <div className="text-center">
                    { coffeeItems.length ? (
                      coffeeItems.map((coffee, i)=>
                        <p key={i}>{coffee.name} - {coffee.size} - ${this.toCurrency(coffee.price)}</p>
                      )
                    ) : <h2>Please add a coffee to proceed</h2>}
                    <h2>Order Total: ${this.toCurrency(this.getTotal())}</h2>
                  </div>

                  <div className="alert alert-warning">
                    <strong>Students:</strong> Please ensure you only order coffees during break times.
                    Coffee will not be served to students outside of break times.
                  </div>

                  <div className="row">
                    <div className="col-xs-6">
                      <a href="#/dashboard"
                        className="btn btn-lg btn-default btn-block">Back</a>
                    </div>
                    <div className="col-xs-6">
                      <a href="#/confirm"
                        className="btn btn-lg btn-primary btn-block"
                        onClick={this.handleNext.bind(this)}
                        disabled={coffeeItems.length < 1}>Next</a>
                    </div>
                  </div>
                </div>
              ) : <h1>Sorry - coffee is not yet available at {person.school.name}</h1>}

            </form>
          </div>
        ) : (
          <h1>Loading...</h1>
        )}

      </div>
    ) : <h1>Loading people...</h1>;
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/pages/Coffee.js